module.exports = __webpack_public_path__ + "static/testimonial-thumb-3-e326eaa728dff17749566fcacfe15740.jpg";